import './App.css';
import HeaderComponent from './components/Header/HeaderComponent';
import Navbar from './components/Navbar/Navbar';
import BannerComponent from './components/Banner/BannerComponent';
import AboutMeSection from './components/Sections/AboutMe';
import ContactSection from './components/Sections/ContactSection';
import FooterComponent from './components/Footer/FooterComponent';
import ServicesSection from './components/Sections/ServicesSection';

import Fab from '@mui/material/Fab';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import Seo from './components/Seo';
import ScrollArrow from './components/ScrollArrow/ScrollArrow';

const theme = createTheme({
  palette: {
    primary: {
      main: '#282c34',
    },
  },
});

function App() {
  const [nextHash, setNextHash] = useState(window.location.hash)
  const [clearServices, setClearServices] = useState(false)


    useEffect(() => {
      // rAF-throttled scroll handler to avoid layout thrashing and jumpy hash updates
      let ticking = false;

      const handleScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          const currentHash = (window.location.hash || '').replace(/^#/, '');
          const elements = document.getElementsByClassName('anchor_tags');
          for (const elem of elements) {
            const distance = window.scrollY - elem.offsetTop;
            const hash = elem.id;

            // when element is near viewport center, update URL without forcing scroll
            if (Math.abs(distance) < 120 && currentHash !== hash) {
              try {
                window.history.replaceState(null, '', '#' + hash);
              } catch (e) {
                // fallback: change hash (may cause jump on some browsers)
                window.location.hash = hash;
              }
            }

            // update internal state for UI (debounced by rAF)
            if (Math.abs(distance) < 250 && nextHash !== hash) {
              setNextHash(hash);
              setClearServices(hash === 'sobremi' || hash === 'home');
            }
          }
          ticking = false;
        });
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => window.removeEventListener('scroll', handleScroll);
  }, [nextHash]);

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        {/* Dynamic SEO: change title/description by section (hash) */}
        {
          (() => {
            const raw = (nextHash || window.location.hash || '').toString();
            const page = raw.replace(/^#/, '') || 'home';
            let title = 'Natalia Saenz - Selección y Liderazgo';
            let description = 'Servicios de selección, liderazgo y gestión de equipos. Coaching, formación y soluciones de Recursos Humanos para pymes.';
            let url = 'https://tudominio.com/';

            if (page === 'sobremi') {
              title = 'Sobre mí — Natalia Saenz';
              description = 'Conoce la trayectoria de Natalia Saenz: coach ontológico y especialista en selección y liderazgo con más de 15 años de experiencia.';
              url = 'https://tudominio.com/#sobremi';
            } else if (page === 'servicios') {
              title = 'Servicios — Selección y Desarrollo de Talento';
              description = 'Servicios integrales de Recursos Humanos: selección, medición de clima, formación y coaching para líderes y equipos.';
              url = 'https://tudominio.com/#servicios';
            } else if (page === 'contacto') {
              title = 'Contacto — Natalia Saenz';
              description = 'Ponte en contacto con Natalia Saenz para soluciones en selección, liderazgo y gestión de equipos.';
              url = 'https://tudominio.com/#contacto';
            }

            return <Seo title={title} description={description} url={url} />;
          })()
        }
        <Navbar/>
        <HeaderComponent/>
        <AboutMeSection currentHash={nextHash}/>
        {/*<div id="servicios" className='App-component anchor_tags'>
          <Grow in={nextHash == 'servicios'}>
            <h2>Servicios Ofrecidos</h2>      
          </Grow>
            <CustomizedTimeline currentHash={nextHash} clear={clearServices}/>
        </div>*/}
  <ServicesSection currentHash={nextHash} clearServices={clearServices} />
        <BannerComponent currentHash={nextHash}/>
        <ContactSection currentHash={nextHash}/>
        <FooterComponent/>
        <ScrollArrow />
      </div>
      <Fab aria-label="add" id='whatsappButton' href="https://wa.me/1533584891">
        <FontAwesomeIcon icon={faWhatsapp} />
      </Fab>
    </ThemeProvider>
  );
}

export default App;
